import { Injectable } from '@angular/core';
import { ConnectionService } from '@services/connection-service/index';
import { RecommendedProduct, RecommendedProductCollection } from '@shared/recommended-products/recommended-products.types';

export interface RecommendedProductsData {
  products: RecommendedProduct[];
  displayType: string;
  shouldShow: boolean;
}

@Injectable({ providedIn: 'root' })
export class RecommendedProductsService {
  private static readonly TAGGED_CARDS = 'TAGGED_CARDS';
  private loading: Promise<RecommendedProductsData> | null = null;

  constructor(private readonly conn: ConnectionService) {}

  load(productLimit: number = 10): Promise<RecommendedProductsData> {
    return this.loading ??= this.fetchAndCache(productLimit);
  }

  private async fetchAndCache(productLimit: number): Promise<RecommendedProductsData> {
    let collection: RecommendedProductCollection;
    try {
      collection = await this.conn.fetchRecommendedProducts(productLimit);
    } catch {
      this.loading = null;
      return { products: [], displayType: '', shouldShow: false };
    }
    const products = (collection?.products || []).filter((product: RecommendedProduct): boolean => !!product?.price);
    const displayType = collection?.displayType || '';
    return { products, displayType, shouldShow: !!products.length && displayType === RecommendedProductsService.TAGGED_CARDS };
  }
}
